export enum HistoryItemType {
  Alarm = 'Alarm',
  Status = 'Status',
}
